import React, { ReactNode, useContext, useState } from "react";
import { MSelect } from "components/Shared";
import { PDFDesignerProviderValue, PhoenixPDFsDesignerContext } from "./PhoenixPdfDesignerContext";
import { PdfDisplayControl, PdfDisplayDefinition } from "interfaces/Phoenix.FormsDesigner.Models";

export interface PdfMoveControlReference {
    destinationSectionId: string,
    controlId: string,
    sourceSection: PdfDisplayControl,
  }

interface Props {
  moveControlReference: PdfMoveControlReference,
  pdfDefinition: PdfDisplayDefinition
}

const MoveSectionDialog = ({ moveControlReference, pdfDefinition }: Props) => {
  const [selectedSection, setSelectedSection] = useState<MSelectOption<string>>();

  const sections = pdfDefinition.displayControls;

  const onSectionChange = (selectedSection: MSelectOption<string>) => {
    moveControlReference.destinationSectionId = selectedSection.value;
    setSelectedSection(selectedSection);
  };

  return (
    <div className="designer-props">
      <MSelect
          placeholder="Select section to move to:"
          options={sections.map(s => ({ value: s.id, label: s.name }))}
          onChange={onSectionChange}
          value={selectedSection}
        />
    </div>
  );
};

export default MoveSectionDialog;